<template>
  <el-card class="wrapper" v-if="stepSelected">
    <div class="stepper">
      <div v-for="(step, index) in stepWithSeparator" class="stepper__step" :key="index">
        <div
          v-if="step !== '-'"
          :class="{'stepper__step__title--active': stepSelected && stepSelected.key === step.key }"
          class="stepper__step__title">
          <div class="stepper__step__title__number">{{ step.index }}</div>
          <div class="stepper__step__title__name">{{ step.name }}</div>
        </div>
        <i v-else class="stepper__step__chevron el-icon-arrow-right"></i>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'stepper',
  props: {
    steps: {
      type: Array,
    },
    stepSelected: {
      type: Object,
    },
  },
  computed: {
    stepWithSeparator() {
      return this.steps.reduce((acc, step, index) => {
        acc.push({
          key: step.key,
          name: step.name,
          index: index + 1,
        });
        if (index !== this.steps.length - 1) {
          acc.push('-');
        }
        return acc;
      }, []);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  border-radius: 0;
  @include breakpoint(tablet) {
    border-radius: 4px;
  }
}
.stepper {
  display: flex;
  width: 100%;
  &__step {
    @include breakpoint(mobile) {
      margin: 0 10px;
    }
    &:first-child {
      margin-left: 0;
      .stepper__step__title__number {
        margin-left: 0;
      }
    }
    &:last-child {
      margin-right: 0;
    }
    &__title {
      user-select: none;
      display: inline-block;
      text-align: center;
      &__name {
        display: inline-block;
        font-size: 12px;
        @include breakpoint(mobile) {
          font-size: 16px;
        }
      }
      &__number {
        display: inline-block;
        height: 36px;
        width: 36px;
        margin: 0 5px;
        padding: 8px;
        border-radius: 50%;
        line-height: 20px;
        text-align: center;
        background-color: $--color-primary;
        color: $--color-white;
        @include breakpoint(tablet) {
          margin-right: 10px;
        }
      }
      &--active {
        .stepper__step__title__name {
          color: $--color-secondary;
        }
        .stepper__step__title__number {
          background-color: $--color-secondary;
        }
      }
    }
    &__chevron {
      line-height: 36px;
    }
  }
}
</style>
